<template>
  <div class="vue-tui-viewer"></div>
</template>

<script>
import TuiEditor from 'tui-editor/dist/tui-editor-Viewer'
import 'tui-editor/dist/tui-editor-contents.css'
import './codemirror.css'

export default {
  props: {
    options: Object,
    content: String
  },
  mounted () {
    this.editor = new TuiEditor(Object.assign({
      el: this.$el,
      height: '300px',
      initialValue: this.content || ''
    }, this.options))
  },
  methods: {
    setContent () {
      // console.log('setContent : ', this.editor)
      this.editor.setMarkdown(this.content)
    }
  },
  watch: {
    content: function (value) {
      this.editor.setValue(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stone-tui-viewer/stone-tui-viewer.vue